export const CONTRACT_STATUS = {
    DEMAND: 0,           // Có nhu cầu
    PENDING: 1,           // Chưa xử lý
    NEED_DOCUMENT: 2,     // Cần bổ sung HS
    NEED_CONSULT: 3,      // Cần tư vấn
    WAIT_PAYMENT: 4,      // Chờ thanh toán
    NEED_CONTRACT: 5,     // Cần soạn HĐ
    WAIT_SIGN: 6,         // Chờ ký HĐ
    NEED_DISBURSE: 7,     // Cần giải ngân
    COMPLETED: 8,         // Hoàn thành
    CANCELLED: 9          // Hủy hợp đồng
};

export const CONTRACT_STATUS_LIST = [
    { value: CONTRACT_STATUS.PENDING, label: 'Chưa xử lý', color: 'warning' },
    { value: CONTRACT_STATUS.NEED_DOCUMENT, label: 'Cần bổ sung HS', color: 'danger' },
    { value: CONTRACT_STATUS.NEED_CONSULT, label: 'Cần tư vấn', color: 'info' },
    { value: CONTRACT_STATUS.WAIT_PAYMENT, label: 'Chờ thanh toán', color: 'primary' },
    { value: CONTRACT_STATUS.NEED_CONTRACT, label: 'Cần soạn HĐ', color: 'secondary' },
    { value: CONTRACT_STATUS.WAIT_SIGN, label: 'Chờ ký HĐ', color: 'dark' },
    { value: CONTRACT_STATUS.NEED_DISBURSE, label: 'Cần giải ngân', color: 'info' },
    { value: CONTRACT_STATUS.COMPLETED, label: 'Hoàn thành', color: 'success' },
    { value: CONTRACT_STATUS.CANCELLED, label: 'Hủy hợp đồng', color: 'light'}
];
export const CONTRACT_STATUS_MAP = {
    [CONTRACT_STATUS.PENDING]: { label: 'Chưa xử lý', color: 'warning' },
    [CONTRACT_STATUS.DEMAND]: { label: 'Có nhu cầu', color: 'demand' },
    [CONTRACT_STATUS.NEED_DOCUMENT]: { label: 'Cần bổ sung HS', color: 'danger' },
    [CONTRACT_STATUS.NEED_CONSULT]: { label: 'Cần tư vấn', color: 'info' },
    [CONTRACT_STATUS.WAIT_PAYMENT]: { label: 'Chờ thanh toán', color: 'primary' },
    [CONTRACT_STATUS.NEED_CONTRACT]: { label: 'Cần soạn HĐ', color: 'secondary' },
    [CONTRACT_STATUS.WAIT_SIGN]: { label: 'Chờ ký HĐ', color: 'danger' },
    [CONTRACT_STATUS.NEED_DISBURSE]: { label: 'Cần giải ngân', color: 'info' },
    [CONTRACT_STATUS.COMPLETED]: { label: 'Hoàn thành', color: 'success' },
    [CONTRACT_STATUS.CANCELLED]: { label: 'Hủy hợp đồng', color: 'light' },
};